import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { SharedModule } from '../../shared.module';
import { ViewerInterface } from '../../interfaces/viewer-interface';
import { ProyectoService } from '../../../users/proyectos/services/proyecto.service';
import { TramiteService } from '../../../users/tramites/services/tramite.service';
import { LoginServices } from '../../../auth/login/services/login.service';

import { HttpClient } from '@angular/common/http';
import {NgIf} from "@angular/common";

@Component({
    selector: 'app-viewer-pdf',
    standalone: true,
    imports: [DialogModule, PdfJsViewerModule, SharedModule, NgIf],
    templateUrl: './viewer-pdf.component.html',
    styleUrls: ['./viewer-pdf.component.scss'],
})
export class ViewerPdfComponent implements OnInit {
    @Input() _showLoader: boolean = false;
    @Input() dialogPdfView = false;
    @Input() viewer!: ViewerInterface;
    @Output() onPdfEmitterClose = new EventEmitter<boolean>();

    @ViewChild('viewer', { static: false })
    public embeddedPdfViewer: { pdfSrc: string; downloadFileName: string } | any;

    onPdfError = new EventEmitter<string>();
    onPdfLoadSuccess = new EventEmitter<void>();

    zoom = 'auto';

    /** pdfSrc holds the blob URL string (not a SafeUrl) */
    pdfSrc: string = '';
    fileName: string = '';

    constructor(
        private proyectoServices: ProyectoService,
        public tramite: TramiteService,
        public loginServices: LoginServices,
        private http: HttpClient
    ) {}

    ngOnInit(): void {
        this.openFileInViewer(this.viewer.hash!, this.viewer.nombre!);
    }

    openFileInViewer(hash: string, fileName: string) {
        
        this.fileName = fileName;
        this._showLoader = true;

        // Build the “inline” URL that requires a JWT in the header
        const rawUrl = new URL(
            this.viewer.idSolicitudExterna === undefined ?
                this.proyectoServices.getSrcFile(hash, 'inline') :
                this.proyectoServices.getSrcFileExpedienteExterno(hash, 'inline', this.viewer.idSolicitudExterna!)
        ).toString();

        let objectUrl: string | undefined;

        this.http.get(rawUrl, { responseType: 'blob' }).subscribe({
            next: (blob: Blob) => {
                // 1) Create a blob URL from the PDF blob
                objectUrl = URL.createObjectURL(blob);
                this.pdfSrc = objectUrl;

                // 2) Now that pdfSrc is set, open the dialog and hide the loader
                this.dialogPdfView = true;
                this._showLoader = false;
            },
            error: (err) => {
                console.error('Error al cargar el PDF:', err);
                this._showLoader = false;
                this.onPdfError.emit('Error al cargar el archivo PDF.');
            },
            complete: () => {
                // 3) Schedule revocation of the blob URL to avoid memory leaks
                if (objectUrl) {
                    setTimeout(() => {
                        URL.revokeObjectURL(objectUrl!);
                    }, 30000);
                }
            },
        });

        // 4) Fallback: if nothing happens in 600ms, ensure loader is hidden
        setTimeout(() => {
            if (this._showLoader) {
                this._showLoader = false;
            }
        }, 600);
    }

    initializePdfViewer() {
        if (this.embeddedPdfViewer) {
            this._showLoader = true;
            this.embeddedPdfViewer.refresh();
        }
    }

    closeViewerPdf() {
        this.dialogPdfView = false;
        this.onPdfEmitterClose.emit(false);
    }

    pdfLoaded(event: any) {
        if (event) {
            this._showLoader = false;
            console.log('PDF cargado correctamente');
            this.onPdfLoadSuccess.emit();
        }
    }

    pdfError(event: any) {
        console.error('Error al cargar el PDF:', event);
        this._showLoader = false;
        this.onPdfError.emit('Error al cargar el archivo PDF.');
    }
}
